module.exports = __webpack_public_path__ + "4fd74ebc80209f3e4d926e2b9830c0b8.png";